
import { supabase } from "@/integrations/supabase/client";
import { Reagent } from "@/types/reagent.types";
import { toast } from "sonner";
import { mapReagentArray } from "../utils/reagentMapper";

/**
 * Fetches reagents owned by the current user
 * @returns Array of the user's reagents
 */
export const fetchMyReagents = async (): Promise<Reagent[]> => {
  try {
    console.log("Fetching my reagents");
    
    // First, get the current user
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError || !userData.user) {
      console.error("Error fetching user:", userError);
      toast.error("You must be logged in to view your reagents");
      return [];
    }
    
    const userId = userData.user.id;
    console.log(`Fetching reagents for user: ${userId}`);
    
    // Fetch reagents owned by this user
    const { data, error } = await supabase
      .from("reagents")
      .select(`
        *,
        profiles:user_id(*),
        categories:category_id(*)
      `)
      .eq("user_id", userId)
      .order("created_at", { ascending: false });
    
    if (error) {
      console.error("Error fetching reagents:", error);
      toast.error("Failed to load your reagents");
      return [];
    }
    
    console.log(`Found ${data.length} reagents`);
    
    // Map the data using the shared reagent mapper
    const reagents: Reagent[] = mapReagentArray(data);
    
    return reagents;
  } catch (error) {
    console.error("Exception fetching my reagents:", error);
    toast.error("An unexpected error occurred");
    return [];
  }
};
